function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg208Kyrgyzstan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "373.008,256 325.198,278.488 350.657,324.793 298.739,314.86 292.162,367.304   255.999,328.735 219.838,367.304 213.259,314.86 161.346,324.792 186.803,278.486 138.994,256 186.804,233.513 161.346,187.207   213.258,197.141 219.841,144.696 255.999,183.266 292.164,144.696 298.739,197.141 350.659,187.207 325.199,233.515 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 256,
    cy: 256,
    r: 72.815
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M219.592,256c-1.753,0-3.485,0.089-5.195,0.26c0.062,10.085,3.712,19.316,9.737,26.487   c3.216-8.652,8.015-16.541,14.068-23.292C232.42,257.231,226.148,256,219.592,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M242.005,295.189c4.374,1.563,9.084,2.42,13.995,2.42c4.912,0,9.621-0.857,13.995-2.42   c-2.384-9.357-7.307-17.711-13.995-24.274C249.312,277.479,244.389,285.833,242.005,295.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M292.033,235.202c-7.195-12.436-20.63-20.811-36.033-20.811c-15.401,0-28.838,8.375-36.033,20.811   c13.117,0.067,25.415,3.633,36.033,9.79C266.617,238.835,278.915,235.268,292.033,235.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M273.796,259.456c6.053,6.751,10.853,14.64,14.069,23.292c6.026-7.171,9.675-16.402,9.738-26.487   c-1.71-0.17-3.442-0.26-5.195-0.26C285.852,256,279.58,257.231,273.796,259.456z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg208Kyrgyzstan);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };